import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const STOCK_REQUEST_URL = `${backendUrl}/stockRequest`;

const initialState = {
  isLoading: false,
  error: null,
  requests: [],
  request: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "stockRequest",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getRequestsSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.requests = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getRequestSuccess(state, action) {
      state.isLoading = false;
      state.request = action.payload;
    },
    clearRequest(state) {
      state.request = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getStockRequests({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(STOCK_REQUEST_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getRequestsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getStockRequest(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${STOCK_REQUEST_URL}/${id}`);
      dispatch(slice.actions.getRequestSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateStockRequest(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${STOCK_REQUEST_URL}/${id}`, data);
      dispatch(slice.actions.getRequestSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function assignWarehouseStoreToLine(stockRequestId, lineId, warehouseStoreId) {
  return async () => {
    const response = await axios.patch(
      `${STOCK_REQUEST_URL}/${stockRequestId}/lines/${lineId}/warehouse-inventory-store`,
      { warehouseStoreId }
    );
    return response.data;
  };
}

export const { clearRequest } = slice.actions;
